import { http } from '@/api/index';

interface Message {
  _id: string;
  subject?: string;
  body: string;
  createdAt: string;
  updatedAt: string;
}

// Get a message by ID
export const getMessage = (messageId: string) => {
  return http.get<Message>(`/messages/${messageId}`);
};

export default {
  getMessage
}; 